import { render, staticRenderFns } from "./StripeOnboardingAlert.vue?vue&type=template&id=4523e3fa&scoped=true&"
import script from "./StripeOnboardingAlert.vue?vue&type=script&lang=js&"
export * from "./StripeOnboardingAlert.vue?vue&type=script&lang=js&"
import style0 from "./StripeOnboardingAlert.vue?vue&type=style&index=0&id=4523e3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4523e3fa",
  null
  
)

export default component.exports